/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * API V1
 * OpenAPI spec version: v1
 */
import type {
  AcceptDocumentPermissionBody,
  AcceptInvite200,
  AddMembersToChat200,
  AddMembersToChatBody,
  AdminCreateReferral200,
  AdminCreateReferralBody,
  AiCreditsPreflight200,
  AiCreditsPreflightParams,
  ApplyOnboardingTemplatesBody,
  AttachChatDocument200,
  AttachUploadParams,
  ChatMentionableUsers200,
  ChatMentionableUsersParams,
  CheckSchoolDomain200,
  CheckSchoolDomainParams,
  CheckoutSubscription200,
  CheckoutSubscriptionBody,
  CreateAuthToken200,
  CreateAuthTokenBody,
  CreateChat200,
  CreateChatBody,
  CreateCourse201,
  CreateCourseBody,
  CreateCourseTeam200,
  CreateCurrentUser200,
  CreateCurrentUserBody,
  CreateDirectChat200,
  CreateDirectChatBody,
  CreateDirectGroupChat200,
  CreateDirectGroupChatBody,
  CreateDocument200,
  CreateDocumentBody,
  CreateDocumentPermission200,
  CreateDocumentPermissionBody,
  CreateFolder200,
  CreateFolderBody,
  CreateInvite200,
  CreateInviteBody,
  CreateMessage200,
  CreateMessageBody,
  CreateProfessor201,
  CreateProfessorBody,
  CreateReaction200,
  CreateReactionParams,
  CreateReferral200,
  CreateSchool201,
  CreateSchoolBody,
  CreateSchoolImport200,
  CreateSchoolImportBody,
  CreateSubscriptionPlan201,
  CreateSubscriptionPlanBody,
  CreateSuperadmin201,
  CreateSuperadminBody,
  CreateTeam200,
  CreateTeamBody,
  CreateUserEmail200,
  CreateUserEmailBody,
  DeleteAuthToken200,
  DeleteInvite200,
  DeleteMessage200,
  DeleteReaction200,
  DeleteReactionParams,
  DeleteUserEmail200,
  DetachChatDocument200,
  DirectUpload,
  DocumentMentionableUsers200,
  DocumentMentionableUsersParams,
  DuplicateDocument200,
  DuplicateDocumentBody,
  DuplicateFolder200,
  DuplicateFolderBody,
  Error,
  FetchDocument200,
  FetchDocumentUserPermissions200,
  FetchNotionPages200,
  FinishDocumentDuplication200,
  FollowTeam200,
  GetAiCreditsBalance200,
  GetAiCreditsBalanceParams,
  GetAuthTest200200,
  GetAuthTestRequireAuth200,
  GetChat200,
  GetChatParams,
  GetCurrentSubscription200,
  GetCurrentSubscriptionParams,
  GetCurrentUser200,
  GetCurrentUserDirectAndGroupChats200,
  GetCurrentUserNotifications200,
  GetCurrentUserNotificationsParams,
  GetDocumentPermissionsAndRequests200,
  GetFileSignedUrlParams,
  GetSubscriptionPlan200,
  GetTeam200,
  GetTeamCoursePreview200,
  GetTeamShort200,
  ImportNotionPages200,
  ImportNotionPagesBody,
  JoinCourses200,
  JoinCoursesBody,
  ListAffiliatedSchools200,
  ListAvailableSubscriptionPlans200,
  ListCourses200,
  ListCoursesParams,
  ListDocumentChats200,
  ListProfessors200,
  ListProfessorsParams,
  ListReferrals200,
  ListReferralsParams,
  ListSchools200,
  ListSchoolsParams,
  ListSubscriptionPlans200,
  ListSuperadmins200,
  ListTeamChats200,
  ListTeamDeletedChats200,
  MarimoToken,
  MarkChatAsRead200,
  MarkChatAsReadBody,
  MarkCurrentUserChatsAsReadBody,
  MarkNotificationsAsReadBody,
  NotionConnectBody,
  NotionConnectionStatus200,
  NotionDisconnect200,
  OpenTeamBillingPortal200,
  OpenTeamBillingPortalBody,
  PendingInvites200,
  RecentDocuments200,
  RecentDocumentsParams,
  RecordAiCreditSpendBody,
  RegisterPushDeviceBody,
  ResendInvite200,
  ResentDocumentPermissionMail200,
  RestoreChat200,
  Result,
  SearchDocuments200,
  SearchDocumentsParams,
  SendSignInLinkBody,
  ShowCourse200,
  ShowSchool200,
  SolicitDocumentPermission200,
  SolicitDocumentPermissionBody,
  StopChatReply200,
  SubmitCourse201,
  SubmitCourseBody,
  SubmitSchool201,
  SubmitSchoolBody,
  SyncDocumentMentionsBody,
  TeamInvites200,
  TeamMemberships200,
  TeamSearch200,
  TeamSearchParams,
  UnfollowTeam200,
  UnregisterPushDeviceBody,
  UpdateChat200,
  UpdateChatBody,
  UpdateCourse200,
  UpdateCourseBody,
  UpdateCurrentUser200,
  UpdateCurrentUserBody,
  UpdateDocument200,
  UpdateDocumentBody,
  UpdateDocumentLock200,
  UpdateDocumentLockBody,
  UpdateDocumentPermission200,
  UpdateDocumentPermissionBody,
  UpdateDocumentPublicFlags200,
  UpdateDocumentPublicFlagsBody,
  UpdateFolder200,
  UpdateFolderBody,
  UpdateFolderPublicScope200,
  UpdateFolderPublicScopeBody,
  UpdateMembership200,
  UpdateMembershipBody,
  UpdateMessage200,
  UpdateMessageBody,
  UpdateProfessor200,
  UpdateProfessorBody,
  UpdateReferral200,
  UpdateReferralBody,
  UpdateSchool200,
  UpdateSchoolBody,
  UpdateSubscriptionPlan200,
  UpdateSubscriptionPlanBody,
  UpdateTeam200,
  UpdateTeamBody,
  Upload,
  UploadDirectBody,
  UploadSchoolLogo201,
  UploadSchoolLogoBody,
  UploadTeamAvatar201,
  UploadTeamAvatarBody,
  UserAuthTokens200,
  UserSearch200,
  UserSearchParams,
  UserTeams200,
  ValidateHandleParams,
  ValidateUsernameParams,
  VerifyUserEmail200,
  VerifyUserEmailBody,
} from "./api.generated.schemas";

import { client } from "./client";
import { multipartFormData } from "./multipartFormData";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary The current user's AI credits for the current period
 */
export const getAiCreditsBalance = (
  params?: GetAiCreditsBalanceParams,
  options?: SecondParameter<typeof client<GetAiCreditsBalance200>>,
) => {
  return client<GetAiCreditsBalance200>(
    { url: `/api/ai_credits/balance`, method: "GET", params },
    options,
  );
};

/**
 * @summary Checks whether the current user can pay for an AI request, before it starts
 */
export const aiCreditsPreflight = (
  params?: AiCreditsPreflightParams,
  options?: SecondParameter<typeof client<AiCreditsPreflight200>>,
) => {
  return client<AiCreditsPreflight200>(
    { url: `/api/ai_credits/preflight`, method: "GET", params },
    options,
  );
};

/**
 * @summary Checks handle format and availability
 */
export const validateHandle = (
  params: ValidateHandleParams,
  options?: SecondParameter<typeof client<Result>>,
) => {
  return client<Result>(
    { url: `/api/assistant/handle_acceptable`, method: "GET", params },
    options,
  );
};

/**
 * @summary returns result
 */
export const getAuthTestRequireAuth = (
  options?: SecondParameter<typeof client<GetAuthTestRequireAuth200>>,
) => {
  return client<GetAuthTestRequireAuth200>(
    { url: `/api/auth-test/require-auth`, method: "GET" },
    options,
  );
};

/**
 * @summary returns result
 */
export const getAuthTest200 = (options?: SecondParameter<typeof client<GetAuthTest200200>>) => {
  return client<GetAuthTest200200>({ url: `/api/auth-test/200`, method: "GET" }, options);
};

/**
 * @summary returns result
 */
export const getAuthTest401 = (options?: SecondParameter<typeof client<unknown>>) => {
  return client<unknown>({ url: `/api/auth-test/401`, method: "GET" }, options);
};

/**
 * @summary returns result
 */
export const getAuthTest403 = (options?: SecondParameter<typeof client<unknown>>) => {
  return client<unknown>({ url: `/api/auth-test/403`, method: "GET" }, options);
};

/**
 * @summary Creates new auth token
 */
export const createAuthToken = (
  createAuthTokenBody: CreateAuthTokenBody,
  options?: SecondParameter<typeof client<CreateAuthToken200>>,
) => {
  return client<CreateAuthToken200>(
    {
      url: `/api/auth_tokens`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAuthTokenBody,
    },
    options,
  );
};

/**
 * @summary Deletes auth token
 */
export const deleteAuthToken = (
  id: string,
  options?: SecondParameter<typeof client<DeleteAuthToken200>>,
) => {
  return client<DeleteAuthToken200>({ url: `/api/auth_tokens/${id}`, method: "DELETE" }, options);
};

/**
 * @summary Creates new chat
 */
export const createChat = (
  createChatBody: CreateChatBody,
  options?: SecondParameter<typeof client<CreateChat200>>,
) => {
  return client<CreateChat200>(
    {
      url: `/api/chats`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createChatBody,
    },
    options,
  );
};

/**
 * @summary Creates new direct chat
 */
export const createDirectChat = (
  createDirectChatBody: CreateDirectChatBody,
  options?: SecondParameter<typeof client<CreateDirectChat200>>,
) => {
  return client<CreateDirectChat200>(
    {
      url: `/api/chats/create_direct`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDirectChatBody,
    },
    options,
  );
};

/**
 * @summary Creates new direct group chat
 */
export const createDirectGroupChat = (
  createDirectGroupChatBody: CreateDirectGroupChatBody,
  options?: SecondParameter<typeof client<CreateDirectGroupChat200>>,
) => {
  return client<CreateDirectGroupChat200>(
    {
      url: `/api/chats/create_group`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDirectGroupChatBody,
    },
    options,
  );
};

/**
 * @summary Fetches chat by :uid
 */
export const getChat = (
  uid: string,
  params?: GetChatParams,
  options?: SecondParameter<typeof client<GetChat200>>,
) => {
  return client<GetChat200>({ url: `/api/chats/${uid}`, method: "GET", params }, options);
};

/**
 * @summary Updates chat metadata
 */
export const updateChat = (
  uid: string,
  updateChatBody: UpdateChatBody,
  options?: SecondParameter<typeof client<UpdateChat200>>,
) => {
  return client<UpdateChat200>(
    {
      url: `/api/chats/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateChatBody,
    },
    options,
  );
};

/**
 * @summary Marks chat as deleted
 */
export const deleteChat = (uid: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/chats/${uid}`, method: "DELETE" }, options);
};

/**
 * @summary Attaches a document to the chat
 */
export const attachChatDocument = (
  uid: string,
  documentUid: string,
  options?: SecondParameter<typeof client<AttachChatDocument200>>,
) => {
  return client<AttachChatDocument200>(
    { url: `/api/chats/${uid}/documents/${documentUid}`, method: "POST" },
    options,
  );
};

/**
 * @summary Detaches a document from the chat
 */
export const detachChatDocument = (
  uid: string,
  documentUid: string,
  options?: SecondParameter<typeof client<DetachChatDocument200>>,
) => {
  return client<DetachChatDocument200>(
    { url: `/api/chats/${uid}/documents/${documentUid}`, method: "DELETE" },
    options,
  );
};

/**
 * @summary Updates unread_messages_count based on :cursor
 */
export const markChatAsRead = (
  uid: string,
  markChatAsReadBody: MarkChatAsReadBody,
  options?: SecondParameter<typeof client<MarkChatAsRead200>>,
) => {
  return client<MarkChatAsRead200>(
    {
      url: `/api/chats/${uid}/mark_as_read`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: markChatAsReadBody,
    },
    options,
  );
};

/**
 * @summary Stops active bot reply
 */
export const stopChatReply = (
  uid: string,
  options?: SecondParameter<typeof client<StopChatReply200>>,
) => {
  return client<StopChatReply200>({ url: `/api/chats/${uid}/stop`, method: "POST" }, options);
};

/**
 * Returns chat participants and the members of the teams behind the chat and its documents, followed by the user with matching username. Capped at 20 results.
 * @summary Fetches the users that can be mentioned in the chat
 */
export const chatMentionableUsers = (
  uid: string,
  params?: ChatMentionableUsersParams,
  options?: SecondParameter<typeof client<ChatMentionableUsers200>>,
) => {
  return client<ChatMentionableUsers200>(
    { url: `/api/chats/${uid}/mentionable_users`, method: "GET", params },
    options,
  );
};

/**
 * @summary Adds new members to direct group chat
 */
export const addMembersToChat = (
  uid: string,
  addMembersToChatBody: AddMembersToChatBody,
  options?: SecondParameter<typeof client<AddMembersToChat200>>,
) => {
  return client<AddMembersToChat200>(
    {
      url: `/api/chats/${uid}/add_members`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addMembersToChatBody,
    },
    options,
  );
};

/**
 * @summary Removes user from direct group chat
 */
export const leaveChat = (uid: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/chats/${uid}/leave`, method: "DELETE" }, options);
};

/**
 * @summary Restores a deleted chat
 */
export const restoreChat = (
  uid: string,
  options?: SecondParameter<typeof client<RestoreChat200>>,
) => {
  return client<RestoreChat200>({ url: `/api/chats/${uid}/restore`, method: "POST" }, options);
};

/**
 * @summary Lists courses
 */
export const listCourses = (
  params?: ListCoursesParams,
  options?: SecondParameter<typeof client<ListCourses200>>,
) => {
  return client<ListCourses200>({ url: `/api/courses`, method: "GET", params }, options);
};

/**
 * @summary Creates a course
 */
export const createCourse = (
  createCourseBody: CreateCourseBody,
  options?: SecondParameter<typeof client<CreateCourse201>>,
) => {
  return client<CreateCourse201>(
    {
      url: `/api/courses`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCourseBody,
    },
    options,
  );
};

/**
 * @summary Shows course
 */
export const showCourse = (
  uid: string,
  options?: SecondParameter<typeof client<ShowCourse200>>,
) => {
  return client<ShowCourse200>({ url: `/api/courses/${uid}`, method: "GET" }, options);
};

/**
 * @summary Updates course
 */
export const updateCourse = (
  uid: string,
  updateCourseBody: UpdateCourseBody,
  options?: SecondParameter<typeof client<UpdateCourse200>>,
) => {
  return client<UpdateCourse200>(
    {
      url: `/api/courses/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateCourseBody,
    },
    options,
  );
};

/**
 * @summary Deletes course, keeping its team
 */
export const deleteCourse = (uid: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/courses/${uid}`, method: "DELETE" }, options);
};

/**
 * Adds the current user to the selected courses' teams as a member, reporting a per-course status. Joining requires school affiliation (a verified email on one of the course school's domains); a school with no domains has nothing to gate on and is open to any signed-in user. The team is created lazily on the first join.
 * @summary Joins course teams
 */
export const joinCourses = (
  joinCoursesBody: JoinCoursesBody,
  options?: SecondParameter<typeof client<JoinCourses200>>,
) => {
  return client<JoinCourses200>(
    {
      url: `/api/courses/join`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: joinCoursesBody,
    },
    options,
  );
};

/**
 * Creates the course team (owned by the course service account) if it does not exist yet — the admin counterpart to the lazy creation on join.
 * @summary Creates the course team
 */
export const createCourseTeam = (
  uid: string,
  options?: SecondParameter<typeof client<CreateCourseTeam200>>,
) => {
  return client<CreateCourseTeam200>({ url: `/api/courses/${uid}/team`, method: "POST" }, options);
};

/**
 * Adds a course the school does not list yet. It is live at once, owned by the default service account until a superadmin accepts it.
 * @summary Submits a course
 */
export const submitCourse = (
  submitCourseBody: SubmitCourseBody,
  options?: SecondParameter<typeof client<SubmitCourse201>>,
) => {
  return client<SubmitCourse201>(
    {
      url: `/api/courses/submit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitCourseBody,
    },
    options,
  );
};

/**
 * @summary Create permission
 */
export const createDocumentPermission = (
  createDocumentPermissionBody: CreateDocumentPermissionBody,
  options?: SecondParameter<typeof client<CreateDocumentPermission200>>,
) => {
  return client<CreateDocumentPermission200>(
    {
      url: `/api/document_permissions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDocumentPermissionBody,
    },
    options,
  );
};

/**
 * @summary Request permission
 */
export const solicitDocumentPermission = (
  solicitDocumentPermissionBody: SolicitDocumentPermissionBody,
  options?: SecondParameter<typeof client<SolicitDocumentPermission200>>,
) => {
  return client<SolicitDocumentPermission200>(
    {
      url: `/api/document_permissions/solicit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: solicitDocumentPermissionBody,
    },
    options,
  );
};

/**
 * @summary Accept permission
 */
export const acceptDocumentPermission = (
  acceptDocumentPermissionBody: AcceptDocumentPermissionBody,
  options?: SecondParameter<typeof client<Result | Result>>,
) => {
  return client<Result | Result>(
    {
      url: `/api/document_permissions/accept`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: acceptDocumentPermissionBody,
    },
    options,
  );
};

/**
 * @summary Update permission
 */
export const updateDocumentPermission = (
  uid: string,
  updateDocumentPermissionBody: UpdateDocumentPermissionBody,
  options?: SecondParameter<typeof client<UpdateDocumentPermission200>>,
) => {
  return client<UpdateDocumentPermission200>(
    {
      url: `/api/document_permissions/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateDocumentPermissionBody,
    },
    options,
  );
};

/**
 * @summary Delete permission
 */
export const deleteDocumentPermission = (
  uid: string,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>({ url: `/api/document_permissions/${uid}`, method: "DELETE" }, options);
};

/**
 * @summary Resend permission mail
 */
export const resentDocumentPermissionMail = (
  uid: string,
  options?: SecondParameter<typeof client<ResentDocumentPermissionMail200>>,
) => {
  return client<ResentDocumentPermissionMail200>(
    { url: `/api/document_permissions/${uid}/resend_mail`, method: "PUT" },
    options,
  );
};

/**
 * Creates document attached to a particular folder/team if parent
        params are present or to user's personal team if not. If document is created
        by unauthorized user, it does not get attached anywhere.
 * @summary Creates new empty document
 */
export const createDocument = (
  createDocumentBody: CreateDocumentBody,
  options?: SecondParameter<typeof client<CreateDocument200>>,
) => {
  return client<CreateDocument200>(
    {
      url: `/api/documents`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createDocumentBody,
    },
    options,
  );
};

/**
 * @summary Renders document
 */
export const fetchDocument = (
  uid: string,
  options?: SecondParameter<typeof client<FetchDocument200>>,
) => {
  return client<FetchDocument200>({ url: `/api/documents/${uid}`, method: "GET" }, options);
};

/**
 * @summary Updates document attributes or moves document
 */
export const updateDocument = (
  uid: string,
  updateDocumentBody: UpdateDocumentBody,
  options?: SecondParameter<typeof client<UpdateDocument200>>,
) => {
  return client<UpdateDocument200>(
    {
      url: `/api/documents/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateDocumentBody,
    },
    options,
  );
};

/**
 * @summary Returns Y.Doc binary state
 */
export const fetchDocumentYDoc = (uid: string, options?: SecondParameter<typeof client<Blob>>) => {
  return client<Blob>(
    { url: `/api/documents/${uid}/y_doc`, method: "GET", responseType: "blob" },
    options,
  );
};

/**
 * @summary Renders document's userPermissions for current user
 */
export const fetchDocumentUserPermissions = (
  uid: string,
  options?: SecondParameter<typeof client<FetchDocumentUserPermissions200>>,
) => {
  return client<FetchDocumentUserPermissions200>(
    { url: `/api/documents/${uid}/permissions`, method: "GET" },
    options,
  );
};

/**
 * @summary Updates document's public flags
 */
export const updateDocumentPublicFlags = (
  uid: string,
  updateDocumentPublicFlagsBody: UpdateDocumentPublicFlagsBody,
  options?: SecondParameter<typeof client<UpdateDocumentPublicFlags200>>,
) => {
  return client<UpdateDocumentPublicFlags200>(
    {
      url: `/api/documents/${uid}/update_public_flags`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateDocumentPublicFlagsBody,
    },
    options,
  );
};

/**
 * @summary Updates document's edit lock
 */
export const updateDocumentLock = (
  uid: string,
  updateDocumentLockBody: UpdateDocumentLockBody,
  options?: SecondParameter<typeof client<UpdateDocumentLock200>>,
) => {
  return client<UpdateDocumentLock200>(
    {
      url: `/api/documents/${uid}/update_lock`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateDocumentLockBody,
    },
    options,
  );
};

/**
 * @summary Duplicates document
 */
export const duplicateDocument = (
  uid: string,
  duplicateDocumentBody: DuplicateDocumentBody,
  options?: SecondParameter<typeof client<DuplicateDocument200>>,
) => {
  return client<DuplicateDocument200>(
    {
      url: `/api/documents/${uid}/duplicate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: duplicateDocumentBody,
    },
    options,
  );
};

/**
 * @summary Lists all chats for a document
 */
export const listDocumentChats = (
  uid: string,
  options?: SecondParameter<typeof client<ListDocumentChats200>>,
) => {
  return client<ListDocumentChats200>(
    { url: `/api/documents/${uid}/chats`, method: "GET" },
    options,
  );
};

/**
 * @summary Renders document permissions and requests
 */
export const getDocumentPermissionsAndRequests = (
  uid: string,
  options?: SecondParameter<typeof client<GetDocumentPermissionsAndRequests200>>,
) => {
  return client<GetDocumentPermissionsAndRequests200>(
    { url: `/api/documents/${uid}/permissions_and_requests`, method: "GET" },
    options,
  );
};

/**
 * @summary Searches for documents that match query
 */
export const searchDocuments = (
  params: SearchDocumentsParams,
  options?: SecondParameter<typeof client<SearchDocuments200>>,
) => {
  return client<SearchDocuments200>(
    { url: `/api/documents/search`, method: "GET", params },
    options,
  );
};

/**
 * @summary Retries document duplication
 */
export const finishDocumentDuplication = (
  uid: string,
  options?: SecondParameter<typeof client<FinishDocumentDuplication200>>,
) => {
  return client<FinishDocumentDuplication200>(
    { url: `/api/documents/${uid}/retry_duplication_finalization`, method: "PUT" },
    options,
  );
};

/**
 * @summary Issues a short-lived JWT scoped to this document for the marimo gateway
 */
export const documentMarimoToken = (
  uid: string,
  options?: SecondParameter<typeof client<MarimoToken>>,
) => {
  return client<MarimoToken>(
    { url: `/api/documents/${uid}/marimo_token`, method: "POST" },
    options,
  );
};

/**
 * Returns team members and users with shared access, followed by the user with matching username. Capped at 20 results.
 * @summary Fetches the users that can be mentioned in the document
 */
export const documentMentionableUsers = (
  uid: string,
  params?: DocumentMentionableUsersParams,
  options?: SecondParameter<typeof client<DocumentMentionableUsers200>>,
) => {
  return client<DocumentMentionableUsers200>(
    { url: `/api/documents/${uid}/mentionable_users`, method: "GET", params },
    options,
  );
};

/**
 * @summary Records that the current user opened the document
 */
export const recordDocumentVisit = (
  uid: string,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>({ url: `/api/documents/${uid}/visit`, method: "POST" }, options);
};

/**
 * @summary Creates new folder
 */
export const createFolder = (
  createFolderBody: CreateFolderBody,
  options?: SecondParameter<typeof client<CreateFolder200>>,
) => {
  return client<CreateFolder200>(
    {
      url: `/api/folders`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createFolderBody,
    },
    options,
  );
};

/**
 * @summary Updates folder attributes or moves folder
 */
export const updateFolder = (
  uid: string,
  updateFolderBody: UpdateFolderBody,
  options?: SecondParameter<typeof client<UpdateFolder200>>,
) => {
  return client<UpdateFolder200>(
    {
      url: `/api/folders/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateFolderBody,
    },
    options,
  );
};

/**
 * @summary Updates folder's public_scope
 */
export const updateFolderPublicScope = (
  uid: string,
  updateFolderPublicScopeBody: UpdateFolderPublicScopeBody,
  options?: SecondParameter<typeof client<UpdateFolderPublicScope200>>,
) => {
  return client<UpdateFolderPublicScope200>(
    {
      url: `/api/folders/${uid}/update_public_scope`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateFolderPublicScopeBody,
    },
    options,
  );
};

/**
 * @summary Duplicate folder with all it's nested files
 */
export const duplicateFolder = (
  uid: string,
  duplicateFolderBody: DuplicateFolderBody,
  options?: SecondParameter<typeof client<DuplicateFolder200>>,
) => {
  return client<DuplicateFolder200>(
    {
      url: `/api/folders/${uid}/duplicate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: duplicateFolderBody,
    },
    options,
  );
};

/**
 * @summary Records a completed AI request
 */
export const recordAiCreditSpend = (
  recordAiCreditSpendBody: RecordAiCreditSpendBody,
  options?: SecondParameter<typeof client<void | Error>>,
) => {
  return client<void | Error>(
    {
      url: `/api/internal/ai_credit_spends`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: recordAiCreditSpendBody,
    },
    options,
  );
};

/**
 * Called by apps/yjs-api on document save, the only party that can read a Y.js body. The whole body is reported every time, so an empty list clears the document's mentions.
 * @summary Replaces a document's mentions with the ones reported
 */
export const syncDocumentMentions = (
  uid: string,
  syncDocumentMentionsBody: SyncDocumentMentionsBody,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>(
    {
      url: `/api/internal/documents/${uid}/mentions`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: syncDocumentMentionsBody,
    },
    options,
  );
};

/**
 * @summary Deletes invite
 */
export const deleteInvite = (
  inviteToken: string,
  options?: SecondParameter<typeof client<DeleteInvite200>>,
) => {
  return client<DeleteInvite200>({ url: `/api/invites/${inviteToken}`, method: "DELETE" }, options);
};

/**
 * @summary Resends invite mail
 */
export const resendInvite = (
  inviteToken: string,
  options?: SecondParameter<typeof client<ResendInvite200>>,
) => {
  return client<ResendInvite200>({ url: `/api/invites/${inviteToken}`, method: "PUT" }, options);
};

/**
 * @summary Creates new team member from invite token
 */
export const acceptInvite = (
  inviteToken: string,
  options?: SecondParameter<typeof client<AcceptInvite200>>,
) => {
  return client<AcceptInvite200>(
    { url: `/api/invites/${inviteToken}/accept`, method: "POST" },
    options,
  );
};

/**
 * @summary Updates membership
 */
export const updateMembership = (
  id: string,
  updateMembershipBody: UpdateMembershipBody,
  options?: SecondParameter<typeof client<UpdateMembership200>>,
) => {
  return client<UpdateMembership200>(
    {
      url: `/api/memberships/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateMembershipBody,
    },
    options,
  );
};

/**
 * @summary Deletes membership
 */
export const deleteMembership = (id: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/memberships/${id}`, method: "DELETE" }, options);
};

/**
 * @summary Creates new message
 */
export const createMessage = (
  createMessageBody: CreateMessageBody,
  options?: SecondParameter<typeof client<CreateMessage200>>,
) => {
  return client<CreateMessage200>(
    {
      url: `/api/messages`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createMessageBody,
    },
    options,
  );
};

/**
 * @summary Updates message
 */
export const updateMessage = (
  uid: string,
  updateMessageBody: UpdateMessageBody,
  options?: SecondParameter<typeof client<UpdateMessage200>>,
) => {
  return client<UpdateMessage200>(
    {
      url: `/api/messages/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateMessageBody,
    },
    options,
  );
};

/**
 * @summary Updates message
 */
export const deleteMessage = (
  uid: string,
  options?: SecondParameter<typeof client<DeleteMessage200>>,
) => {
  return client<DeleteMessage200>({ url: `/api/messages/${uid}`, method: "DELETE" }, options);
};

/**
 * @summary Marks user's notifications as read by :ids
 */
export const markNotificationsAsRead = (
  markNotificationsAsReadBody: MarkNotificationsAsReadBody,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>(
    {
      url: `/api/notifications/mark_as_read`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: markNotificationsAsReadBody,
    },
    options,
  );
};

/**
 * @summary Check connection status
 */
export const notionConnectionStatus = (
  options?: SecondParameter<typeof client<NotionConnectionStatus200>>,
) => {
  return client<NotionConnectionStatus200>(
    { url: `/api/notion/connection_status`, method: "GET" },
    options,
  );
};

/**
 * @summary Create notion oauth connection
 */
export const notionConnect = (
  notionConnectBody: NotionConnectBody,
  options?: SecondParameter<typeof client<unknown>>,
) => {
  return client<unknown>(
    {
      url: `/api/notion/connect`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: notionConnectBody,
    },
    options,
  );
};

/**
 * @summary Fetch notion pages
 */
export const fetchNotionPages = (options?: SecondParameter<typeof client<FetchNotionPages200>>) => {
  return client<FetchNotionPages200>({ url: `/api/notion/pages`, method: "GET" }, options);
};

/**
 * @summary Import notion pages to documents
 */
export const importNotionPages = (
  importNotionPagesBody: ImportNotionPagesBody,
  options?: SecondParameter<typeof client<ImportNotionPages200>>,
) => {
  return client<ImportNotionPages200>(
    {
      url: `/api/notion/import`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: importNotionPagesBody,
    },
    options,
  );
};

/**
 * @summary Delete notion oauth connection
 */
export const notionDisconnect = (options?: SecondParameter<typeof client<NotionDisconnect200>>) => {
  return client<NotionDisconnect200>({ url: `/api/notion/disconnect`, method: "DELETE" }, options);
};

/**
 * @summary Lists professors
 */
export const listProfessors = (
  params?: ListProfessorsParams,
  options?: SecondParameter<typeof client<ListProfessors200>>,
) => {
  return client<ListProfessors200>({ url: `/api/professors`, method: "GET", params }, options);
};

/**
 * @summary Creates professor
 */
export const createProfessor = (
  createProfessorBody: CreateProfessorBody,
  options?: SecondParameter<typeof client<CreateProfessor201>>,
) => {
  return client<CreateProfessor201>(
    {
      url: `/api/professors`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createProfessorBody,
    },
    options,
  );
};

/**
 * @summary Renames professor
 */
export const updateProfessor = (
  uid: string,
  updateProfessorBody: UpdateProfessorBody,
  options?: SecondParameter<typeof client<UpdateProfessor200>>,
) => {
  return client<UpdateProfessor200>(
    {
      url: `/api/professors/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateProfessorBody,
    },
    options,
  );
};

/**
 * @summary Deletes professor, unlinking them from courses
 */
export const deleteProfessor = (uid: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/professors/${uid}`, method: "DELETE" }, options);
};

/**
 * @summary Registers the device's push token for the current user
 */
export const registerPushDevice = (
  registerPushDeviceBody: RegisterPushDeviceBody,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>(
    {
      url: `/api/push_devices`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerPushDeviceBody,
    },
    options,
  );
};

/**
 * @summary Unregisters the device's push token
 */
export const unregisterPushDevice = (
  unregisterPushDeviceBody: UnregisterPushDeviceBody,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>(
    {
      url: `/api/push_devices`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: unregisterPushDeviceBody,
    },
    options,
  );
};

/**
 * @summary Creates new reaction
 */
export const createReaction = (
  uid: string,
  params: CreateReactionParams,
  options?: SecondParameter<typeof client<CreateReaction200>>,
) => {
  return client<CreateReaction200>(
    { url: `/api/reactions/${uid}`, method: "POST", params },
    options,
  );
};

/**
 * @summary Deletes reaction
 */
export const deleteReaction = (
  uid: string,
  params: DeleteReactionParams,
  options?: SecondParameter<typeof client<DeleteReaction200>>,
) => {
  return client<DeleteReaction200>(
    { url: `/api/reactions/${uid}`, method: "DELETE", params },
    options,
  );
};

/**
 * @summary Lists referrals
 */
export const listReferrals = (
  params?: ListReferralsParams,
  options?: SecondParameter<typeof client<ListReferrals200>>,
) => {
  return client<ListReferrals200>({ url: `/api/referrals`, method: "GET", params }, options);
};

/**
 * @summary Creates referral
 */
export const createReferral = (options?: SecondParameter<typeof client<CreateReferral200>>) => {
  return client<CreateReferral200>({ url: `/api/referrals`, method: "POST" }, options);
};

/**
 * @summary Creates anonymous referral
 */
export const adminCreateReferral = (
  adminCreateReferralBody: AdminCreateReferralBody,
  options?: SecondParameter<typeof client<AdminCreateReferral200>>,
) => {
  return client<AdminCreateReferral200>(
    {
      url: `/api/referrals/admin_create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: adminCreateReferralBody,
    },
    options,
  );
};

/**
 * @summary Updates referral
 */
export const updateReferral = (
  token: string,
  updateReferralBody: UpdateReferralBody,
  options?: SecondParameter<typeof client<UpdateReferral200>>,
) => {
  return client<UpdateReferral200>(
    {
      url: `/api/referrals/${token}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateReferralBody,
    },
    options,
  );
};

/**
 * @summary Deletes referral
 */
export const deleteReferral = (token: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/referrals/${token}`, method: "DELETE" }, options);
};

/**
 * @summary Imports schools, courses and professors from a JSON file
 */
export const createSchoolImport = (
  createSchoolImportBody: CreateSchoolImportBody,
  options?: SecondParameter<typeof client<CreateSchoolImport200>>,
) => {
  const formData = multipartFormData(createSchoolImportBody);
  return client<CreateSchoolImport200>(
    {
      url: `/api/school_imports`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

/**
 * @summary Lists schools
 */
export const listSchools = (
  params?: ListSchoolsParams,
  options?: SecondParameter<typeof client<ListSchools200>>,
) => {
  return client<ListSchools200>({ url: `/api/schools`, method: "GET", params }, options);
};

/**
 * @summary Creates school
 */
export const createSchool = (
  createSchoolBody: CreateSchoolBody,
  options?: SecondParameter<typeof client<CreateSchool201>>,
) => {
  return client<CreateSchool201>(
    {
      url: `/api/schools`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSchoolBody,
    },
    options,
  );
};

/**
 * Adds a school the directory lacks, on review until a superadmin accepts it.
 * @summary Submits a school
 */
export const submitSchool = (
  submitSchoolBody: SubmitSchoolBody,
  options?: SecondParameter<typeof client<SubmitSchool201>>,
) => {
  return client<SubmitSchool201>(
    {
      url: `/api/schools/submit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitSchoolBody,
    },
    options,
  );
};

/**
 * Answers the school submission guards for a domain before the student verifies an address at it.
 * @summary Checks an email domain
 */
export const checkSchoolDomain = (
  params: CheckSchoolDomainParams,
  options?: SecondParameter<typeof client<CheckSchoolDomain200>>,
) => {
  return client<CheckSchoolDomain200>(
    { url: `/api/schools/check_domain`, method: "GET", params },
    options,
  );
};

/**
 * @summary Shows school
 */
export const showSchool = (
  uid: string,
  options?: SecondParameter<typeof client<ShowSchool200>>,
) => {
  return client<ShowSchool200>({ url: `/api/schools/${uid}`, method: "GET" }, options);
};

/**
 * @summary Updates school
 */
export const updateSchool = (
  uid: string,
  updateSchoolBody: UpdateSchoolBody,
  options?: SecondParameter<typeof client<UpdateSchool200>>,
) => {
  return client<UpdateSchool200>(
    {
      url: `/api/schools/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateSchoolBody,
    },
    options,
  );
};

/**
 * @summary Deletes school
 */
export const deleteSchool = (uid: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/schools/${uid}`, method: "DELETE" }, options);
};

/**
 * @summary Uploads school logo
 */
export const uploadSchoolLogo = (
  uid: string,
  uploadSchoolLogoBody: UploadSchoolLogoBody,
  options?: SecondParameter<typeof client<UploadSchoolLogo201>>,
) => {
  const formData = multipartFormData(uploadSchoolLogoBody);
  return client<UploadSchoolLogo201>(
    {
      url: `/api/schools/${uid}/logo`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

/**
 * Legacy, kept for mobile builds that predate the shared-domain school picker: every school the current user is affiliated with, by name, unpaginated. New clients use `GET /api/schools?affiliated=true`.
 * @deprecated
 * @summary Lists affiliated schools (legacy)
 */
export const listAffiliatedSchools = (
  options?: SecondParameter<typeof client<ListAffiliatedSchools200>>,
) => {
  return client<ListAffiliatedSchools200>(
    { url: `/api/schools/affiliated`, method: "GET" },
    options,
  );
};

/**
 * @summary Lists subscription plans
 */
export const listSubscriptionPlans = (
  options?: SecondParameter<typeof client<ListSubscriptionPlans200>>,
) => {
  return client<ListSubscriptionPlans200>(
    { url: `/api/subscription_plans`, method: "GET" },
    options,
  );
};

/**
 * @summary Creates a subscription plan
 */
export const createSubscriptionPlan = (
  createSubscriptionPlanBody: CreateSubscriptionPlanBody,
  options?: SecondParameter<typeof client<CreateSubscriptionPlan201>>,
) => {
  return client<CreateSubscriptionPlan201>(
    {
      url: `/api/subscription_plans`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSubscriptionPlanBody,
    },
    options,
  );
};

/**
 * @summary Lists subscription plans currently offered to users
 */
export const listAvailableSubscriptionPlans = (
  options?: SecondParameter<typeof client<ListAvailableSubscriptionPlans200>>,
) => {
  return client<ListAvailableSubscriptionPlans200>(
    { url: `/api/subscription_plans/available`, method: "GET" },
    options,
  );
};

/**
 * @summary Shows a subscription plan
 */
export const getSubscriptionPlan = (
  uid: string,
  options?: SecondParameter<typeof client<GetSubscriptionPlan200>>,
) => {
  return client<GetSubscriptionPlan200>(
    { url: `/api/subscription_plans/${uid}`, method: "GET" },
    options,
  );
};

/**
 * @summary Updates a subscription plan
 */
export const updateSubscriptionPlan = (
  uid: string,
  updateSubscriptionPlanBody: UpdateSubscriptionPlanBody,
  options?: SecondParameter<typeof client<UpdateSubscriptionPlan200>>,
) => {
  return client<UpdateSubscriptionPlan200>(
    {
      url: `/api/subscription_plans/${uid}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateSubscriptionPlanBody,
    },
    options,
  );
};

/**
 * @summary Shows the active subscription of a team, the user's personal team by default
 */
export const getCurrentSubscription = (
  params?: GetCurrentSubscriptionParams,
  options?: SecondParameter<typeof client<GetCurrentSubscription200>>,
) => {
  return client<GetCurrentSubscription200>(
    { url: `/api/subscriptions/current`, method: "GET", params },
    options,
  );
};

/**
 * @summary Opens a Stripe Checkout session subscribing a team, the user's personal team by default
 */
export const checkoutSubscription = (
  checkoutSubscriptionBody: CheckoutSubscriptionBody,
  options?: SecondParameter<typeof client<CheckoutSubscription200>>,
) => {
  return client<CheckoutSubscription200>(
    {
      url: `/api/subscriptions/checkout`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checkoutSubscriptionBody,
    },
    options,
  );
};

/**
 * @summary Creates new teams
 */
export const createTeam = (
  createTeamBody: CreateTeamBody,
  options?: SecondParameter<typeof client<CreateTeam200>>,
) => {
  return client<CreateTeam200>(
    {
      url: `/api/teams`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTeamBody,
    },
    options,
  );
};

/**
 * @summary Fetches team by :permalink
 */
export const getTeam = (
  permalink: string,
  options?: SecondParameter<typeof client<GetTeam200>>,
) => {
  return client<GetTeam200>({ url: `/api/teams/${permalink}`, method: "GET" }, options);
};

/**
 * @summary Updates team by :permalink
 */
export const updateTeam = (
  permalink: string,
  updateTeamBody: UpdateTeamBody,
  options?: SecondParameter<typeof client<UpdateTeam200>>,
) => {
  return client<UpdateTeam200>(
    {
      url: `/api/teams/${permalink}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateTeamBody,
    },
    options,
  );
};

/**
 * @summary Fetches team by :permalink without folders/documents
 */
export const getTeamShort = (
  permalink: string,
  options?: SecondParameter<typeof client<GetTeamShort200>>,
) => {
  return client<GetTeamShort200>({ url: `/api/teams/${permalink}/short`, method: "GET" }, options);
};

/**
 * The course a team was created for, its school, and a roster preview
(avatars of the first five members that have one) — what a non-member
sees on a class document instead of the document. Public, like the
team itself; the full roster stays members-only.

 * @summary Fetches a preview of the class behind a course team
 */
export const getTeamCoursePreview = (
  permalink: string,
  options?: SecondParameter<typeof client<GetTeamCoursePreview200>>,
) => {
  return client<GetTeamCoursePreview200>(
    { url: `/api/teams/${permalink}/course_preview`, method: "GET" },
    options,
  );
};

/**
 * @summary Lists all team memberships
 */
export const teamMemberships = (
  permalink: string,
  options?: SecondParameter<typeof client<TeamMemberships200>>,
) => {
  return client<TeamMemberships200>(
    { url: `/api/teams/${permalink}/memberships`, method: "GET" },
    options,
  );
};

/**
 * @summary Lists team chats visible to the current user
 */
export const listTeamChats = (
  permalink: string,
  options?: SecondParameter<typeof client<ListTeamChats200>>,
) => {
  return client<ListTeamChats200>({ url: `/api/teams/${permalink}/chats`, method: "GET" }, options);
};

/**
 * @summary Lists deleted team channels
 */
export const listTeamDeletedChats = (
  permalink: string,
  options?: SecondParameter<typeof client<ListTeamDeletedChats200>>,
) => {
  return client<ListTeamDeletedChats200>(
    { url: `/api/teams/${permalink}/deleted_chats`, method: "GET" },
    options,
  );
};

/**
 * @summary Deletes user membership in team
 */
export const leaveTeam = (permalink: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/teams/${permalink}/leave`, method: "DELETE" }, options);
};

/**
 * @summary Creates new invite to team
 */
export const createInvite = (
  permalink: string,
  createInviteBody: CreateInviteBody,
  options?: SecondParameter<typeof client<CreateInvite200>>,
) => {
  return client<CreateInvite200>(
    {
      url: `/api/teams/${permalink}/create_invite`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createInviteBody,
    },
    options,
  );
};

/**
 * @summary Fetches all team invites
 */
export const teamInvites = (
  permalink: string,
  options?: SecondParameter<typeof client<TeamInvites200>>,
) => {
  return client<TeamInvites200>({ url: `/api/teams/${permalink}/invites`, method: "GET" }, options);
};

/**
 * @summary Uploads avatar
 */
export const uploadTeamAvatar = (
  permalink: string,
  uploadTeamAvatarBody: UploadTeamAvatarBody,
  options?: SecondParameter<typeof client<UploadTeamAvatar201>>,
) => {
  const formData = multipartFormData(uploadTeamAvatarBody);
  return client<UploadTeamAvatar201>(
    {
      url: `/api/teams/${permalink}/upload_avatar`,
      method: "PUT",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

/**
 * @summary Creates follow
 */
export const followTeam = (
  permalink: string,
  options?: SecondParameter<typeof client<FollowTeam200>>,
) => {
  return client<FollowTeam200>({ url: `/api/teams/${permalink}/follow`, method: "POST" }, options);
};

/**
 * @summary Deletes follow
 */
export const unfollowTeam = (
  permalink: string,
  options?: SecondParameter<typeof client<UnfollowTeam200>>,
) => {
  return client<UnfollowTeam200>(
    { url: `/api/teams/${permalink}/unfollow`, method: "DELETE" },
    options,
  );
};

/**
 * @summary Fetches all teams with matching permalinks/titles
 */
export const teamSearch = (
  params: TeamSearchParams,
  options?: SecondParameter<typeof client<TeamSearch200>>,
) => {
  return client<TeamSearch200>({ url: `/api/teams/search`, method: "GET", params }, options);
};

/**
 * @summary Opens a Stripe Billing Portal session for the team
 */
export const openTeamBillingPortal = (
  permalink: string,
  openTeamBillingPortalBody: OpenTeamBillingPortalBody,
  options?: SecondParameter<typeof client<OpenTeamBillingPortal200>>,
) => {
  return client<OpenTeamBillingPortal200>(
    {
      url: `/api/teams/${permalink}/billing_portal`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: openTeamBillingPortalBody,
    },
    options,
  );
};

/**
 * @summary Creates unattached blob
 */
export const uploadDirect = (
  uploadDirectBody: UploadDirectBody,
  options?: SecondParameter<typeof client<DirectUpload>>,
) => {
  return client<DirectUpload>(
    {
      url: `/api/uploads/direct_create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: uploadDirectBody,
    },
    options,
  );
};

/**
 * @summary Retrieves a file from a document or chat
 */
export const getFileSignedUrl = (
  entityType: "document" | "chat",
  uid: string,
  key: string,
  params?: GetFileSignedUrlParams,
  options?: SecondParameter<typeof client<Upload>>,
) => {
  return client<Upload>(
    { url: `/api/uploads/${entityType}/${uid}/signed_url/${key}`, method: "GET", params },
    options,
  );
};

/**
 * @summary Attaches an uploaded blob to a document or chat
 */
export const attachUpload = (
  entityType: "document" | "chat",
  uid: string,
  key: string,
  params?: AttachUploadParams,
  options?: SecondParameter<typeof client<Upload>>,
) => {
  return client<Upload>(
    { url: `/api/uploads/${entityType}/${uid}/attach/${key}`, method: "POST", params },
    options,
  );
};

/**
 * @summary Adds an email to the current user and sends a verification code
 */
export const createUserEmail = (
  createUserEmailBody: CreateUserEmailBody,
  options?: SecondParameter<typeof client<CreateUserEmail200>>,
) => {
  return client<CreateUserEmail200>(
    {
      url: `/api/user_emails`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createUserEmailBody,
    },
    options,
  );
};

/**
 * @summary Verifies an email with the mailed code
 */
export const verifyUserEmail = (
  uid: string,
  verifyUserEmailBody: VerifyUserEmailBody,
  options?: SecondParameter<typeof client<VerifyUserEmail200>>,
) => {
  return client<VerifyUserEmail200>(
    {
      url: `/api/user_emails/${uid}/verify`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: verifyUserEmailBody,
    },
    options,
  );
};

/**
 * @summary Deletes a secondary email
 */
export const deleteUserEmail = (
  uid: string,
  options?: SecondParameter<typeof client<DeleteUserEmail200>>,
) => {
  return client<DeleteUserEmail200>({ url: `/api/user_emails/${uid}`, method: "DELETE" }, options);
};

/**
 * Returns user if it exist or authData if not
 * @summary Retrieves current user data
 */
export const getCurrentUser = (options?: SecondParameter<typeof client<GetCurrentUser200>>) => {
  return client<GetCurrentUser200>({ url: `/api/users/current`, method: "GET" }, options);
};

/**
 * @summary Creates current user based on FB token and params
 */
export const createCurrentUser = (
  createCurrentUserBody: CreateCurrentUserBody,
  options?: SecondParameter<typeof client<CreateCurrentUser200>>,
) => {
  return client<CreateCurrentUser200>(
    {
      url: `/api/users/current`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCurrentUserBody,
    },
    options,
  );
};

/**
 * @summary Updates current user based on FB token and params
 */
export const updateCurrentUser = (
  updateCurrentUserBody: UpdateCurrentUserBody,
  options?: SecondParameter<typeof client<UpdateCurrentUser200>>,
) => {
  return client<UpdateCurrentUser200>(
    {
      url: `/api/users/current`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateCurrentUserBody,
    },
    options,
  );
};

/**
 * @summary Checks username format and availability
 */
export const validateUsername = (
  params: ValidateUsernameParams,
  options?: SecondParameter<typeof client<Result>>,
) => {
  return client<Result>({ url: `/api/users/username_acceptable`, method: "GET", params }, options);
};

/**
 * @summary Emails a Firebase sign-in link to the given address
 */
export const sendSignInLink = (
  sendSignInLinkBody: SendSignInLinkBody,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>(
    {
      url: `/api/users/send_sign_in_link`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendSignInLinkBody,
    },
    options,
  );
};

/**
 * @summary Fetches user's teams with all the nested folders and documents
 */
export const userTeams = (options?: SecondParameter<typeof client<UserTeams200>>) => {
  return client<UserTeams200>({ url: `/api/users/teams`, method: "GET" }, options);
};

/**
 * @summary Fetches all user's auth tokens
 */
export const userAuthTokens = (options?: SecondParameter<typeof client<UserAuthTokens200>>) => {
  return client<UserAuthTokens200>({ url: `/api/users/auth_tokens`, method: "GET" }, options);
};

/**
 * @summary Fetches all user's invites
 */
export const pendingInvites = (options?: SecondParameter<typeof client<PendingInvites200>>) => {
  return client<PendingInvites200>({ url: `/api/users/pending_invites`, method: "GET" }, options);
};

/**
 * @summary Duplicates role-based onboarding documents into the personal team
 */
export const applyOnboardingTemplates = (
  applyOnboardingTemplatesBody: ApplyOnboardingTemplatesBody,
  options?: SecondParameter<typeof client<void>>,
) => {
  return client<void>(
    {
      url: `/api/users/onboarding_templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: applyOnboardingTemplatesBody,
    },
    options,
  );
};

/**
 * @summary Fetches all users with matching usernames/names
 */
export const userSearch = (
  params: UserSearchParams,
  options?: SecondParameter<typeof client<UserSearch200>>,
) => {
  return client<UserSearch200>({ url: `/api/users/search`, method: "GET", params }, options);
};

/**
 * @summary Marks all chats that user participates in as read
 */
export const markCurrentUserChatsAsRead = (
  markCurrentUserChatsAsReadBody: MarkCurrentUserChatsAsReadBody,
  options?: SecondParameter<typeof client<Result>>,
) => {
  return client<Result>(
    {
      url: `/api/users/mark_chats_as_read`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: markCurrentUserChatsAsReadBody,
    },
    options,
  );
};

/**
 * @summary Fetches user's notifications
 */
export const getCurrentUserNotifications = (
  params?: GetCurrentUserNotificationsParams,
  options?: SecondParameter<typeof client<GetCurrentUserNotifications200>>,
) => {
  return client<GetCurrentUserNotifications200>(
    { url: `/api/users/notifications`, method: "GET", params },
    options,
  );
};

/**
 * @summary Fetches the documents the user opened most recently in a team
 */
export const recentDocuments = (
  params: RecentDocumentsParams,
  options?: SecondParameter<typeof client<RecentDocuments200>>,
) => {
  return client<RecentDocuments200>(
    { url: `/api/users/recent_documents`, method: "GET", params },
    options,
  );
};

/**
 * @summary Fetches user's direct and group chats
 */
export const getCurrentUserDirectAndGroupChats = (
  options?: SecondParameter<typeof client<GetCurrentUserDirectAndGroupChats200>>,
) => {
  return client<GetCurrentUserDirectAndGroupChats200>(
    { url: `/api/users/direct_and_group_chats`, method: "GET" },
    options,
  );
};

/**
 * @summary Lists all superadmins
 */
export const listSuperadmins = (options?: SecondParameter<typeof client<ListSuperadmins200>>) => {
  return client<ListSuperadmins200>({ url: `/api/users/superadmins`, method: "GET" }, options);
};

/**
 * @summary Grants superadmin to a user by username
 */
export const createSuperadmin = (
  createSuperadminBody: CreateSuperadminBody,
  options?: SecondParameter<typeof client<CreateSuperadmin201>>,
) => {
  return client<CreateSuperadmin201>(
    {
      url: `/api/users/superadmins`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSuperadminBody,
    },
    options,
  );
};

/**
 * @summary Revokes superadmin from a user
 */
export const deleteSuperadmin = (uid: string, options?: SecondParameter<typeof client<void>>) => {
  return client<void>({ url: `/api/users/superadmins/${uid}`, method: "DELETE" }, options);
};

export type GetAiCreditsBalanceResult = NonNullable<
  Awaited<ReturnType<typeof getAiCreditsBalance>>
>;
export type AiCreditsPreflightResult = NonNullable<Awaited<ReturnType<typeof aiCreditsPreflight>>>;
export type ValidateHandleResult = NonNullable<Awaited<ReturnType<typeof validateHandle>>>;
export type GetAuthTestRequireAuthResult = NonNullable<
  Awaited<ReturnType<typeof getAuthTestRequireAuth>>
>;
export type GetAuthTest200Result = NonNullable<Awaited<ReturnType<typeof getAuthTest200>>>;
export type GetAuthTest401Result = NonNullable<Awaited<ReturnType<typeof getAuthTest401>>>;
export type GetAuthTest403Result = NonNullable<Awaited<ReturnType<typeof getAuthTest403>>>;
export type CreateAuthTokenResult = NonNullable<Awaited<ReturnType<typeof createAuthToken>>>;
export type DeleteAuthTokenResult = NonNullable<Awaited<ReturnType<typeof deleteAuthToken>>>;
export type CreateChatResult = NonNullable<Awaited<ReturnType<typeof createChat>>>;
export type CreateDirectChatResult = NonNullable<Awaited<ReturnType<typeof createDirectChat>>>;
export type CreateDirectGroupChatResult = NonNullable<
  Awaited<ReturnType<typeof createDirectGroupChat>>
>;
export type GetChatResult = NonNullable<Awaited<ReturnType<typeof getChat>>>;
export type UpdateChatResult = NonNullable<Awaited<ReturnType<typeof updateChat>>>;
export type DeleteChatResult = NonNullable<Awaited<ReturnType<typeof deleteChat>>>;
export type AttachChatDocumentResult = NonNullable<Awaited<ReturnType<typeof attachChatDocument>>>;
export type DetachChatDocumentResult = NonNullable<Awaited<ReturnType<typeof detachChatDocument>>>;
export type MarkChatAsReadResult = NonNullable<Awaited<ReturnType<typeof markChatAsRead>>>;
export type StopChatReplyResult = NonNullable<Awaited<ReturnType<typeof stopChatReply>>>;
export type ChatMentionableUsersResult = NonNullable<
  Awaited<ReturnType<typeof chatMentionableUsers>>
>;
export type AddMembersToChatResult = NonNullable<Awaited<ReturnType<typeof addMembersToChat>>>;
export type LeaveChatResult = NonNullable<Awaited<ReturnType<typeof leaveChat>>>;
export type RestoreChatResult = NonNullable<Awaited<ReturnType<typeof restoreChat>>>;
export type ListCoursesResult = NonNullable<Awaited<ReturnType<typeof listCourses>>>;
export type CreateCourseResult = NonNullable<Awaited<ReturnType<typeof createCourse>>>;
export type ShowCourseResult = NonNullable<Awaited<ReturnType<typeof showCourse>>>;
export type UpdateCourseResult = NonNullable<Awaited<ReturnType<typeof updateCourse>>>;
export type DeleteCourseResult = NonNullable<Awaited<ReturnType<typeof deleteCourse>>>;
export type JoinCoursesResult = NonNullable<Awaited<ReturnType<typeof joinCourses>>>;
export type CreateCourseTeamResult = NonNullable<Awaited<ReturnType<typeof createCourseTeam>>>;
export type SubmitCourseResult = NonNullable<Awaited<ReturnType<typeof submitCourse>>>;
export type CreateDocumentPermissionResult = NonNullable<
  Awaited<ReturnType<typeof createDocumentPermission>>
>;
export type SolicitDocumentPermissionResult = NonNullable<
  Awaited<ReturnType<typeof solicitDocumentPermission>>
>;
export type AcceptDocumentPermissionResult = NonNullable<
  Awaited<ReturnType<typeof acceptDocumentPermission>>
>;
export type UpdateDocumentPermissionResult = NonNullable<
  Awaited<ReturnType<typeof updateDocumentPermission>>
>;
export type DeleteDocumentPermissionResult = NonNullable<
  Awaited<ReturnType<typeof deleteDocumentPermission>>
>;
export type ResentDocumentPermissionMailResult = NonNullable<
  Awaited<ReturnType<typeof resentDocumentPermissionMail>>
>;
export type CreateDocumentResult = NonNullable<Awaited<ReturnType<typeof createDocument>>>;
export type FetchDocumentResult = NonNullable<Awaited<ReturnType<typeof fetchDocument>>>;
export type UpdateDocumentResult = NonNullable<Awaited<ReturnType<typeof updateDocument>>>;
export type FetchDocumentYDocResult = NonNullable<Awaited<ReturnType<typeof fetchDocumentYDoc>>>;
export type FetchDocumentUserPermissionsResult = NonNullable<
  Awaited<ReturnType<typeof fetchDocumentUserPermissions>>
>;
export type UpdateDocumentPublicFlagsResult = NonNullable<
  Awaited<ReturnType<typeof updateDocumentPublicFlags>>
>;
export type UpdateDocumentLockResult = NonNullable<Awaited<ReturnType<typeof updateDocumentLock>>>;
export type DuplicateDocumentResult = NonNullable<Awaited<ReturnType<typeof duplicateDocument>>>;
export type ListDocumentChatsResult = NonNullable<Awaited<ReturnType<typeof listDocumentChats>>>;
export type GetDocumentPermissionsAndRequestsResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentPermissionsAndRequests>>
>;
export type SearchDocumentsResult = NonNullable<Awaited<ReturnType<typeof searchDocuments>>>;
export type FinishDocumentDuplicationResult = NonNullable<
  Awaited<ReturnType<typeof finishDocumentDuplication>>
>;
export type DocumentMarimoTokenResult = NonNullable<
  Awaited<ReturnType<typeof documentMarimoToken>>
>;
export type DocumentMentionableUsersResult = NonNullable<
  Awaited<ReturnType<typeof documentMentionableUsers>>
>;
export type RecordDocumentVisitResult = NonNullable<
  Awaited<ReturnType<typeof recordDocumentVisit>>
>;
export type CreateFolderResult = NonNullable<Awaited<ReturnType<typeof createFolder>>>;
export type UpdateFolderResult = NonNullable<Awaited<ReturnType<typeof updateFolder>>>;
export type UpdateFolderPublicScopeResult = NonNullable<
  Awaited<ReturnType<typeof updateFolderPublicScope>>
>;
export type DuplicateFolderResult = NonNullable<Awaited<ReturnType<typeof duplicateFolder>>>;
export type RecordAiCreditSpendResult = NonNullable<
  Awaited<ReturnType<typeof recordAiCreditSpend>>
>;
export type SyncDocumentMentionsResult = NonNullable<
  Awaited<ReturnType<typeof syncDocumentMentions>>
>;
export type DeleteInviteResult = NonNullable<Awaited<ReturnType<typeof deleteInvite>>>;
export type ResendInviteResult = NonNullable<Awaited<ReturnType<typeof resendInvite>>>;
export type AcceptInviteResult = NonNullable<Awaited<ReturnType<typeof acceptInvite>>>;
export type UpdateMembershipResult = NonNullable<Awaited<ReturnType<typeof updateMembership>>>;
export type DeleteMembershipResult = NonNullable<Awaited<ReturnType<typeof deleteMembership>>>;
export type CreateMessageResult = NonNullable<Awaited<ReturnType<typeof createMessage>>>;
export type UpdateMessageResult = NonNullable<Awaited<ReturnType<typeof updateMessage>>>;
export type DeleteMessageResult = NonNullable<Awaited<ReturnType<typeof deleteMessage>>>;
export type MarkNotificationsAsReadResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsAsRead>>
>;
export type NotionConnectionStatusResult = NonNullable<
  Awaited<ReturnType<typeof notionConnectionStatus>>
>;
export type NotionConnectResult = NonNullable<Awaited<ReturnType<typeof notionConnect>>>;
export type FetchNotionPagesResult = NonNullable<Awaited<ReturnType<typeof fetchNotionPages>>>;
export type ImportNotionPagesResult = NonNullable<Awaited<ReturnType<typeof importNotionPages>>>;
export type NotionDisconnectResult = NonNullable<Awaited<ReturnType<typeof notionDisconnect>>>;
export type ListProfessorsResult = NonNullable<Awaited<ReturnType<typeof listProfessors>>>;
export type CreateProfessorResult = NonNullable<Awaited<ReturnType<typeof createProfessor>>>;
export type UpdateProfessorResult = NonNullable<Awaited<ReturnType<typeof updateProfessor>>>;
export type DeleteProfessorResult = NonNullable<Awaited<ReturnType<typeof deleteProfessor>>>;
export type RegisterPushDeviceResult = NonNullable<Awaited<ReturnType<typeof registerPushDevice>>>;
export type UnregisterPushDeviceResult = NonNullable<
  Awaited<ReturnType<typeof unregisterPushDevice>>
>;
export type CreateReactionResult = NonNullable<Awaited<ReturnType<typeof createReaction>>>;
export type DeleteReactionResult = NonNullable<Awaited<ReturnType<typeof deleteReaction>>>;
export type ListReferralsResult = NonNullable<Awaited<ReturnType<typeof listReferrals>>>;
export type CreateReferralResult = NonNullable<Awaited<ReturnType<typeof createReferral>>>;
export type AdminCreateReferralResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateReferral>>
>;
export type UpdateReferralResult = NonNullable<Awaited<ReturnType<typeof updateReferral>>>;
export type DeleteReferralResult = NonNullable<Awaited<ReturnType<typeof deleteReferral>>>;
export type CreateSchoolImportResult = NonNullable<Awaited<ReturnType<typeof createSchoolImport>>>;
export type ListSchoolsResult = NonNullable<Awaited<ReturnType<typeof listSchools>>>;
export type CreateSchoolResult = NonNullable<Awaited<ReturnType<typeof createSchool>>>;
export type SubmitSchoolResult = NonNullable<Awaited<ReturnType<typeof submitSchool>>>;
export type CheckSchoolDomainResult = NonNullable<Awaited<ReturnType<typeof checkSchoolDomain>>>;
export type ShowSchoolResult = NonNullable<Awaited<ReturnType<typeof showSchool>>>;
export type UpdateSchoolResult = NonNullable<Awaited<ReturnType<typeof updateSchool>>>;
export type DeleteSchoolResult = NonNullable<Awaited<ReturnType<typeof deleteSchool>>>;
export type UploadSchoolLogoResult = NonNullable<Awaited<ReturnType<typeof uploadSchoolLogo>>>;
export type ListAffiliatedSchoolsResult = NonNullable<
  Awaited<ReturnType<typeof listAffiliatedSchools>>
>;
export type ListSubscriptionPlansResult = NonNullable<
  Awaited<ReturnType<typeof listSubscriptionPlans>>
>;
export type CreateSubscriptionPlanResult = NonNullable<
  Awaited<ReturnType<typeof createSubscriptionPlan>>
>;
export type ListAvailableSubscriptionPlansResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableSubscriptionPlans>>
>;
export type GetSubscriptionPlanResult = NonNullable<
  Awaited<ReturnType<typeof getSubscriptionPlan>>
>;
export type UpdateSubscriptionPlanResult = NonNullable<
  Awaited<ReturnType<typeof updateSubscriptionPlan>>
>;
export type GetCurrentSubscriptionResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentSubscription>>
>;
export type CheckoutSubscriptionResult = NonNullable<
  Awaited<ReturnType<typeof checkoutSubscription>>
>;
export type CreateTeamResult = NonNullable<Awaited<ReturnType<typeof createTeam>>>;
export type GetTeamResult = NonNullable<Awaited<ReturnType<typeof getTeam>>>;
export type UpdateTeamResult = NonNullable<Awaited<ReturnType<typeof updateTeam>>>;
export type GetTeamShortResult = NonNullable<Awaited<ReturnType<typeof getTeamShort>>>;
export type GetTeamCoursePreviewResult = NonNullable<
  Awaited<ReturnType<typeof getTeamCoursePreview>>
>;
export type TeamMembershipsResult = NonNullable<Awaited<ReturnType<typeof teamMemberships>>>;
export type ListTeamChatsResult = NonNullable<Awaited<ReturnType<typeof listTeamChats>>>;
export type ListTeamDeletedChatsResult = NonNullable<
  Awaited<ReturnType<typeof listTeamDeletedChats>>
>;
export type LeaveTeamResult = NonNullable<Awaited<ReturnType<typeof leaveTeam>>>;
export type CreateInviteResult = NonNullable<Awaited<ReturnType<typeof createInvite>>>;
export type TeamInvitesResult = NonNullable<Awaited<ReturnType<typeof teamInvites>>>;
export type UploadTeamAvatarResult = NonNullable<Awaited<ReturnType<typeof uploadTeamAvatar>>>;
export type FollowTeamResult = NonNullable<Awaited<ReturnType<typeof followTeam>>>;
export type UnfollowTeamResult = NonNullable<Awaited<ReturnType<typeof unfollowTeam>>>;
export type TeamSearchResult = NonNullable<Awaited<ReturnType<typeof teamSearch>>>;
export type OpenTeamBillingPortalResult = NonNullable<
  Awaited<ReturnType<typeof openTeamBillingPortal>>
>;
export type UploadDirectResult = NonNullable<Awaited<ReturnType<typeof uploadDirect>>>;
export type GetFileSignedUrlResult = NonNullable<Awaited<ReturnType<typeof getFileSignedUrl>>>;
export type AttachUploadResult = NonNullable<Awaited<ReturnType<typeof attachUpload>>>;
export type CreateUserEmailResult = NonNullable<Awaited<ReturnType<typeof createUserEmail>>>;
export type VerifyUserEmailResult = NonNullable<Awaited<ReturnType<typeof verifyUserEmail>>>;
export type DeleteUserEmailResult = NonNullable<Awaited<ReturnType<typeof deleteUserEmail>>>;
export type GetCurrentUserResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>;
export type CreateCurrentUserResult = NonNullable<Awaited<ReturnType<typeof createCurrentUser>>>;
export type UpdateCurrentUserResult = NonNullable<Awaited<ReturnType<typeof updateCurrentUser>>>;
export type ValidateUsernameResult = NonNullable<Awaited<ReturnType<typeof validateUsername>>>;
export type SendSignInLinkResult = NonNullable<Awaited<ReturnType<typeof sendSignInLink>>>;
export type UserTeamsResult = NonNullable<Awaited<ReturnType<typeof userTeams>>>;
export type UserAuthTokensResult = NonNullable<Awaited<ReturnType<typeof userAuthTokens>>>;
export type PendingInvitesResult = NonNullable<Awaited<ReturnType<typeof pendingInvites>>>;
export type ApplyOnboardingTemplatesResult = NonNullable<
  Awaited<ReturnType<typeof applyOnboardingTemplates>>
>;
export type UserSearchResult = NonNullable<Awaited<ReturnType<typeof userSearch>>>;
export type MarkCurrentUserChatsAsReadResult = NonNullable<
  Awaited<ReturnType<typeof markCurrentUserChatsAsRead>>
>;
export type GetCurrentUserNotificationsResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUserNotifications>>
>;
export type RecentDocumentsResult = NonNullable<Awaited<ReturnType<typeof recentDocuments>>>;
export type GetCurrentUserDirectAndGroupChatsResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUserDirectAndGroupChats>>
>;
export type ListSuperadminsResult = NonNullable<Awaited<ReturnType<typeof listSuperadmins>>>;
export type CreateSuperadminResult = NonNullable<Awaited<ReturnType<typeof createSuperadmin>>>;
export type DeleteSuperadminResult = NonNullable<Awaited<ReturnType<typeof deleteSuperadmin>>>;
